import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import {NavButton} from '@apps-common/ui-components/NavBar/NavMenuButton';
import {THEME_VARIANTS} from '@apps-common/ui-theme/Constants';
import {useColorScheme} from '@mui/material';

export const ManualThemeSwitcher: React.FC = () => {
  const {mode, setMode} = useColorScheme();

  const switchTheme = (): void => {
    const newMode = mode === THEME_VARIANTS.DARK ? THEME_VARIANTS.LIGHT : THEME_VARIANTS.DARK;
    setMode(newMode);
  };

  return (
    <NavButton key="theme-switch" onClick={switchTheme}>
      {mode === THEME_VARIANTS.DARK ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
    </NavButton>
  );
};
